import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { AuthService } from "src/app/providers/auth.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { StorageService } from "src/app/providers/storage.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { YoutubeEmbedVideoComponent } from "../new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { MatDialog } from "@angular/material/dialog";
import { SelectBusinessCountryComponent } from "src/app/shared/components/select-business-country/select-business-country.component";
import { NewEmployeeJobOfferComponent } from "../new-v2-component/new-employee-job-offer/new-employee-job-offer.component";

@Component({
  selector: "sm-new-dashboard",
  templateUrl: "./new-dashboard.component.html",
  styleUrls: ["./new-dashboard.component.scss"],
})
export class NewDashboardComponent implements OnInit, OnDestroy {
  isMessagingListVisible: boolean = false;
  selectedLanguage: any = localStorage.getItem("appLanguage")
    ? localStorage.getItem("appLanguage")
    : "en";
  selectLanguage: any;
  public loader: boolean = true;
  public loaderForBusiness: boolean = true;
  private _apiSubscription: Subscription;
  businessListData: {}[] = [];
  userDetail: any;
  constructor(
    private navservice: NavigationService,
    private ls: LoaderServiceService,
    private router: Router,
    private route: ActivatedRoute,
    private _apiService: ApiService,
    private _authservice: AuthService,
    private storageservice: StorageService,
    private dialog:MatDialog,
    private _storageService: StorageService
  ) {
    this.navservice.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      console.log(resData);
      
      if (resData.responseType === SM_CONSTANTS.GET_USER_DETAIL_RESULT) {
        this.userDetail = {};
        if (resData.result) {
          if (
            !resData.result.profileHashId ||
            resData.result.profileHashId == "null"
          ) {
            this._authservice.onSignOut();
          } else {
            this.userDetail = resData.result;
            localStorage.setItem(SM_CONSTANTS.OWNER_NAME, this.userDetail.name);
            localStorage.setItem(
              SM_CONSTANTS.PROFILE_HASH,
              this.userDetail.profileHashId
            );

            localStorage.setItem(SM_CONSTANTS.PROFILE_CODE, this.userDetail.profile_code)
            localStorage.setItem(
              SM_CONSTANTS.OWNER_IMAGE,
              this.userDetail.profileThumbImg
            );
            this._storageService.setLocalStorageValue(
              SM_CONSTANTS.KEY_ACCOUNT_COUNTRY_CODE,
              this.userDetail.country_code
            );

            let prfId = this.userDetail.profileHashId;
            document.cookie = `prfId=${prfId};Domain=.lookzup.com;Max-Age=2592000;Path=/;`;

            this.userDetail.addressInfo = typeof this.userDetail.addressInfo == 'string' ? JSON.parse(this.userDetail.addressInfo) : this.userDetail.addressInfo
            this.loader = false;

           
          }
        }
        this._apiService.getMessagesByID()
        this._apiService.getMessageNotificationStatus()
      }

      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_BASIC_ENTITY_LIST){
        this.businessListData = []
        if(resData.result){
          resData.result.forEach((element:any) => {
            this.businessListData.push(element)
          });
        }
        this.ls.showLoader = false
        this.loaderForBusiness = false
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_JOB_INVITATIONS){
    
        if(resData.result){
          if(this.isfromthis){
            this.isfromthis = false
            let dialogref = this.dialog.open(NewEmployeeJobOfferComponent,{
              width: '400px',
              data:{
                jobOfferData:resData.result
              }
            })
          }
        }
        
      }
    });
  }
  isfromthis:boolean = false
  ngOnInit(): void {
       this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
      queryParamsHandling: "", // Clears all other params
      replaceUrl: true,
    });
    if(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID) && localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID) != 'null'){

      this.ls.showLoader = true
      this.loader = true
      this._apiService.getUserDetail(
        localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)
      );
      this.loaderForBusiness = true
      this._apiService.getBasicEntityList()
      this.isfromthis = true
      this._apiService.getJobInvitations(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_COUNTRY_CODE), localStorage.getItem(SM_CONSTANTS.KEY_NEW_ACCOUNT_PHONE_NUMBER),'1')
    }
    
   
  }
  selectcountry(){
    this.ls.showLoader = true
    let dialogref = this.dialog.open(SelectBusinessCountryComponent,{
    width:'500px',
    disableClose:true,
    data:{
      link:"",
      title: 'Select business country',
      ref: this.dialog
    }})
    dialogref.afterClosed().subscribe(res => {
      if(res){
        this.router.navigate(['purchased-plan']);
      }
    } 
    )
    }
  createNewBusiness(){
    // this._modelRef.open(CreateNewBusinessComponent, {
    //   width: '500px',
    //   data: {
    //     title: 'Create Business',
    //     ref: this._modelRef
    //   },
    // });
    this.router.navigate(['purchased-plan']);
}
  toggleMessagingList() {
    this.isMessagingListVisible = !this.isMessagingListVisible;
  }

  alltodaybooking() {
    console.log('all-today-bookings')
    this.router.navigate(['all-today-bookings'])
  }

  bookingdetails() {
    this.router.navigate(["new-business-details"]);
  }
  newservices() {
    this.router.navigate(["service-list"]);
  }
  newservicehours() {
    this.router.navigate(["business-hours"]);
  }
  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }
  Newbooking(){
    this.router.navigate(['new-booking'])
  }
  

  openvideo(){
    this.dialog.open(YoutubeEmbedVideoComponent,{
    width:'1000px',
    disableClose:true,
    data:{
      link:"https://www.youtube.com/embed/mgThLT05rKs?si=zYK1dlOQNfzxHSat",
      title: 'How to Add Business in LookzUp Web Portal? '
    }})
    }

}
